export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const CLEAR_ERRORS = 'CLEAR_ERRORS'

export const SET_MESSAGE = "SET_MESSAGE";
